<template>
  <div>
    <ul class="nav nav-tabs nav tabs-bordered" data-test="support-tabs">
      <li :class="{ active: activeSection == 1 }">
        <router-link
          to="/support/region-support"
          data-test="support-tab-support"
        >
          <span>{{ trans("menu.support") }}</span>
        </router-link>
      </li>
      <li :class="{ active: activeSection == 4 }">
        <router-link to="/support/contact" data-test="support-tab-contact">
          <span>{{ trans("support.tabLabelContact") }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["activeSection"],
};
</script>
